import { SxProps } from '@mui/material';

export const selectedLocationContainerSX: SxProps = {
	borderColor: 'grey.50',
	borderRadius: '3px',
	borderWidth: '1px',
	borderStyle: 'solid',
	padding: '10px',
	gap: '10px',
};

export const selectedLocationTagContainerSX: SxProps = {
	display: 'flex',
	flexDirection: 'row',
  alignItems: 'center',
	gap: 0.625,
};

export const selectedLocationTagSX: SxProps = {
	backgroundColor: 'grey.500',
	borderRadius: '3px',
	color: 'white',
	paddingX: '8px',
	paddingY: '2px',
};

export const selectedLocationTagTextSX: SxProps = {
	color: 'grey.500',
};

export const selectedLocationLocalityTextSX: SxProps = {
	color: 'grey.500',
};
